import { useState } from "react";
import PropTypes from "prop-types";
import IconTriangleUp from "../../layout/others/icon_triangle_up.svg";
import IconTriangleDown from "../../layout/others/icon_triangle_down.svg";
import { useTranslation } from "react-i18next";

const SortedHeader = ({
  searchObject,
  sort,
  setSearchObject,
  headers,
  setHeaders,
  tableEditor
}) => {
  const { t } = useTranslation();
  const [isAscending, setIsAscending] = useState(false);

  const sortTableHeader = (header, index, sortAscending) => {
    let _searchobject = { ...searchObject };
    if (sortAscending === false) {
      _searchobject.orderby = header.field;
      _searchobject.order = 0;
      if (sort) {
        sort(_searchobject);
      } else {
        setSearchObject(_searchobject);
      }
      setHeadersValue(index, true);
    } else if (sortAscending === true) {
      _searchobject.orderby = header.field;
      _searchobject.order = 1;
      if (sort) {
        sort(_searchobject);
      } else {
        setSearchObject(_searchobject);
      }
      setHeadersValue(index, false);
    }
    setIsAscending(!isAscending);
  };

  const setHeadersValue = (index, ascd) => {
    let _headers = [...headers];
    _headers[index].sorted = ascd;
    setHeaders(_headers);
  };

  return (
    <tr className="precandidates-header-row text-nowrap">
      {headers.map((header, index) => {
        return (
          <th
            key={index}
            title={header.title}
            style={header.style}
            className={header === headers[headers.length - 1] && "text-end"}
          >
            {!header.field && header.icon ? (
              header.icon()
            ) : !header.field ? (
              <span className="header-label">{t(header.label)}</span>
            ) : (
              <span
                onClick={() => {
                  sortTableHeader(header, index, isAscending);
                }}
                className="header-label"
              >
                {t(header.label)}

                {header.sorted ? (
                  <img
                    src={IconTriangleUp}
                    alt="arrow"
                    className={`filter-arrow ${
                      header.sorted ? "arrow-up" : "arrow-down"
                    }`}
                  />
                ) : (
                  <img
                    src={IconTriangleDown}
                    alt="arrow"
                    className="hidden-arrow"
                  />
                )}
              </span>
            )}

            {header === headers[headers.length - 1] && tableEditor && (
              <span
                onClick={() => tableEditor()}
                className="me-4"
                role="button"
              >
                {" "}
                <i class="bi bi-gear"></i>
              </span>
            )}
          </th>
        );
      })}
    </tr>
  );
};

SortedHeader.propTypes = {
  searchObject: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  setSearchObject: PropTypes.func.isRequired,
  sort: PropTypes.func,
  setHeaders: PropTypes.func.isRequired
};

export default SortedHeader;
